import { render, staticRenderFns } from "./ProgressStandalone.vue?vue&type=template&id=c70ff518&lang=html&"
import script from "./ProgressStandalone.vue?vue&type=script&lang=js&"
export * from "./ProgressStandalone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports